import React from 'react';

import BaseForm from 'components/BaseForm/BaseForm';
import FiltersSubForms from 'components/FiltersSubForms';
import { useApi } from 'hooks/ApiStoreContext';
import { useFOFilterContext } from 'hooks/FOFilterStoreContext';
import { CSSUtils } from 'utils/CSSUtils';

import {
  DashboardFOFilter,
  DashboardForcesOrdreFilterForm,
} from '../../../types';

import { FormFooter } from './FormFooter';

import './FormFooter/FormFooter.less';

interface FilterFormProps {
  filter: Partial<DashboardForcesOrdreFilterForm>;
  setFilter: (value: Partial<DashboardForcesOrdreFilterForm>) => void;
}

function FilterFormForces({
  filter,
  setFilter,
}: FilterFormProps): React.ReactElement {
  const { ReferentielControllerApi: refController } = useApi();

  const [, , actionsRequises] = useFOFilterContext();

  const initialsFilter = { ...filter };

  const subForms = FiltersSubForms(refController, actionsRequises);

  return (
    <BaseForm
      initialValues={initialsFilter}
      onChange={(changed, all: Partial<DashboardFOFilter>) => {
        return {
          ...all,
          idModele: changed.idMarque ? undefined : all.idModele,
        };
      }}
      subForms={[
        {
          title: 'Général',
          inputs: [
            subForms.statut,
            subForms.classement,
            subForms.fourriere,
            subForms.listUniteFo,
            subForms.commune,
            subForms.actionsRequises,
            subForms.includeDossiersAnonymises,
            subForms.includeOnlyNotDetruitApresSorti,
          ],
        },
        {
          title: 'Mise en fourrière',
          inputs: [
            subForms.natureMiseEnFourriere,
            subForms.dateRangeMiseEnFourriere,
          ],
        },
        {
          title: 'Suivi de mise en fourrière',
          inputs: [
            subForms.dateRangeOrdreDestruction,
            subForms.dateRangeBonEnlevement,
            subForms.dateRangeSortieDefinitive,
            subForms.motifDeSortie,
          ],
        },
        {
          title: 'Véhicule',
          inputs: [subForms.marque, subForms.modele],
        },
      ]}
      onSubmit={() => Promise.resolve()}
      renderButtonAction={() => <FormFooter setFilter={setFilter} />}
      wrapperCol={{ span: CSSUtils.LlargeWrapperCol }}
    />
  );
}

export default FilterFormForces;
